import TagsFilter from './tags-filter.js'
const tagsFilterEl = document.querySelector('[data-tags-filter-url]')

if (
  document.documentElement.dataset.es11 === 'true'
  && 'fetch' in window
  && tagsFilterEl
) {
  const resourceFilter = new TagsFilter(tagsFilterEl)
}

